import { Injectable } from '@angular/core';
import { Actions, Select, Store } from '@ngxs/store';
import { PerformanceTeamPersonalReview } from 'app/library/performance-personal-review/models/performance-team-personal-review.model';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import {
    FetchPerformanceProfilePersonalReviews,
    FetchPerformanceProfilePersonalReviewsFailure,
    FetchPerformanceProfilePersonalReviewsSuccess,
    UpdatePerformanceProfilePersonalReview,
    UpdatePerformanceProfilePersonalReviewFailure,
    UpdatePerformanceProfilePersonalReviewSuccess,
} from '../actions/index';
import { PerformanceProfilePersonalReview } from '../models/performance-profile-personal-review.model';
import { PerformanceProfilePersonalReviewState } from '../models/performance-profile-personal-review.state';

@Injectable()
export class PerformanceProfilePersonalReviewService {
    @Select(PerformanceProfilePersonalReviewState.getEntity)
    performanceProfilePersonalReview$: Observable<PerformanceProfilePersonalReview>;

    constructor(private _store: Store, private _action$: Actions, private _actionHelper: NgxsActionHelper) {}

    getPerformanceProfilePersonalReviewById(performanceProfilePersonalReviewId: string): PerformanceProfilePersonalReview {
        return PerformanceProfilePersonalReviewState.getEntity(this._store.selectSnapshot(PerformanceProfilePersonalReviewState), performanceProfilePersonalReviewId);
    }

    async fetchPerformanceProfilePersonalReviews(userId: string, pageSize: number, pageNumber: number): Promise<boolean> {
        this._store.dispatch(new FetchPerformanceProfilePersonalReviews({ userId, pageSize, pageNumber }));

        return await this._actionHelper.race(FetchPerformanceProfilePersonalReviewsSuccess, FetchPerformanceProfilePersonalReviewsFailure).toPromise();
    }

    async updatePerformanceProfilePersonalReview(review: PerformanceProfilePersonalReview | PerformanceTeamPersonalReview, teamReviewId: string): Promise<boolean> {
        this._store.dispatch(new UpdatePerformanceProfilePersonalReview({ review, teamReviewId }));

        return await this._actionHelper.race(UpdatePerformanceProfilePersonalReviewSuccess, UpdatePerformanceProfilePersonalReviewFailure).toPromise();
    }
}
